/**
 * Created by r4zi4l on 09.02.2021
 */

const Map2dAdviceMergeLogic = function (options) {
    options = options || {};

    Map2dAdviceBaseLogic.call(this, options);

    this.minUnits = options.minUnits || 3;
    this.highlight = options.highlight;

    if (this.targets && this.targets.some(Unit.Equals.bind(Unit, { code: "crystal", stage: 3 }))) {
        this.useCrystal = true;
    }
};

Map2dAdviceMergeLogic.prototype = Object.create(Map2dAdviceBaseLogic.prototype);
Map2dAdviceMergeLogic.prototype.constructor = Map2dAdviceMergeLogic;

Map2dAdviceMergeLogic.prototype.getShowHintTimeout = function () {
    return 2500;
};

Map2dAdviceMergeLogic.prototype.findMove = function () {
    const map = Map2d.currentMap;
    const units = [];
    const crystals = [];

    this.listAvailableUnits().forEach((unit) => {
        if (Unit.Equals(unit, { code: "crystal", stage: 3 })) {
            crystals.push(unit);
        } else {
            units.push(unit);
        }
    }, this);

    const center = map.getScreenCenterCell();
    let minUnits = this.minUnits;
    let crystal;

    if (this.useCrystal) {
        if (!crystals.length) {
            return;
        }

        crystal = crystals.sort((a, b) => cc.getDistanceChebyshev(center, a) - cc.getDistanceChebyshev(center, b))[0];
        minUnits -= 1;
    }

    const used = {};
    let clusters = [];

    units.forEach((unit) => {
        if (used[Unit.GetPositionKey(unit)]) {
            return;
        }
        used[Unit.GetPositionKey(unit)] = true;

        const cells = map.bfs(unit.x, unit.y, map.compareMergeable.bind(map, unit));
        if (!cells.length) {
            return;
        }

        cells.forEach((cell) => {
            used[Unit.GetPositionKey(cell)] = true;
        });

        const clusterCenter = cc.getCenterPoint(cells);
        const isScreenCluster = map.isScreenCellPosition(clusterCenter.x, clusterCenter.y);

        const centerScreenDistance = cc.getDistanceChebyshev(center, clusterCenter);

        clusters.push({
            code: unit.code,
            stage: unit.stage,
            full: Boolean(cells.length >= minUnits),
            weight: Boolean(isScreenCluster) * 1000 + cells.length + 1 / (centerScreenDistance + 1),
            cells
        });
    });

    if (!clusters.length) {
        return;
    }

    clusters.sort((a, b) => b.full - a.full || b.weight - a.weight);

    let selected = {
        code: clusters[0].code,
        stage: clusters[0].stage,
        cells: clusters[0].cells
    };

    if (selected.cells.length < minUnits) {
        clusters = this.chooseBiggestClustersFamily(clusters);
        selected = {
            code: clusters[0].code,
            stage: clusters[0].stage,
            cells: clusters.slice(0, 10).reduce((cells, cluster) => cells.concat(cluster.cells), [])
        };
    }

    if (selected.cells.length < minUnits) {
        const dragged = Map2d.currentMap.dragging;
        if (!dragged || !Unit.IsApplicable(selected, dragged)) {
            return;
        }
    }

    const cells = this.chooseTargets(selected.cells);
    if (cells && cells.length > 1) {
        selected.cells.sort((a) => (a === cells[1] ? -1 : 1));

        if (this.highlight) {
            const highlight = clusters.reduce((result, cluster) => (Unit.Equals(selected, cluster) ? result.concat(cluster.cells) : result), []);

            return {
                cells: selected.cells.slice(0, 1),
                highlight,
                arrow: selected.cells[0],
                fingerDrag: [selected.cells[0]]
            };
        }

        if (crystal) {
            cells.unshift(cc.p(crystal));
            selected.cells.unshift(cc.p(crystal));
        }

        return {
            cells,
            mergeCluster: selected.cells,
            arrow: cells[0],
            fingerDrag: cells
        };
    }
};

Map2dAdviceMergeLogic.prototype.chooseBiggestClustersFamily = function (clusters) {
    const groups = {};

    clusters.forEach((cluster) => {
        const key = Unit.GetKey(cluster);

        if (!groups[key]) {
            groups[key] = {
                code: cluster.code,
                stage: cluster.stage,
                amount: 0,
                clusters: []
            };
        }

        groups[key].amount += cluster.cells.length;
        groups[key].clusters.push(cluster);
    });

    let bestGroup;
    let bestAmount = 0;

    Object.values(groups).forEach((group) => {
        if (group.amount > bestAmount) {
            bestGroup = group;
            bestAmount = group.amount;
        }
    });

    return bestGroup.clusters;
};

Map2dAdviceMergeLogic.prototype.chooseTargets = function (cells) {
    const central = cc.p(0, 0);
    cells.forEach((cell) => {
        central.x += cell.x;
        central.y += cell.y;
    });
    central.x /= cells.length;
    central.y /= cells.length;

    let centerClosest = cells[0];
    let centerFarthest = cells[0];
    let minDistance = cc.pDistance(central, centerClosest);
    let maxDistance = minDistance;

    for (let i = 1; i < cells.length; i++) {
        const distance = cc.pDistance(central, cells[i]);
        if (distance < minDistance) {
            minDistance = distance;
            centerClosest = cells[i];
        }
        if (distance > maxDistance) {
            maxDistance = distance;
            centerFarthest = cells[i];
        }
    }

    if (centerFarthest === centerClosest) {
        centerFarthest = PseudoRandom.GET().choose(cells.filter((cell) => cell !== centerClosest));
    }

    return (centerFarthest && centerClosest) ? [centerFarthest, centerClosest] : undefined;
};